import { Styles } from "../../config"
const styles = {
    container: {
        margin: "100px 0px 75px",
        width: "100%"
    },
    gridContainer: {
        display: "flex",
        justifyContent: "flex-end"
    },
    gridItem: {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "flex-start"
    },
    logoContainer: {
        padding: "0px 50px 0px 0px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        "&:hover": {
            bgcolor: Styles.Color.transparent
        }
    },
    logo: {
        width: "225px",
        objectFit: "contain"
    },
    header: {
        fontFamily: "'Poppins', sans-serif !important",
        color: "#465578",
        fontWeight: "600 !important",
        fontSize: "14px",
        marginBottom: "15px"
    },
    link: {
        fontFamily: "'Poppins', sans-serif !important",
        color: "#6579a8 !important",
        fontSize: "14px !important",
        fontWeight: "400 !important",
        textDecoration: "none",
        marginBottom: "15px",
        letterSpacing: "normal !important",
        lineHeight: "1.8 !important",
        "&:hover": {
            color: "#6c63ff !important",
            cursor: "pointer"
        }
    }
}
export default styles